import PlatformCapabilities from '@/Capabilities';
import AnalyticsTracking from '@/Plugins/AnalyticsTracking';

export async function registerServiceWorker() {
    try {
        if ('serviceWorker' in navigator && PlatformCapabilities.pushCapability) {
            const registration = await navigator.serviceWorker.register('/sw.js', { updateViaCache: 'none' } );

            promoteWaitingWorker(registration);
        }
    }
    catch (error) {
        const analyticsTracking = new AnalyticsTracking();
        analyticsTracking.sendCustomEvent({
            category: 'error',
            action: 'service-worker-registration',
            label: `Service Worker registration failed: ${error}`,
        });
    }
}

// Nothing reloads the page here: the worker only answers navigations and serves the offline
// page, so a running bundle cannot go stale against a newly activated one.
function promoteWaitingWorker(registration) {
    const watched = new WeakSet();

    // A new worker can be in either slot by the time we look, and updatefound does not fire for one
    // that was already installing when this page loaded - so read both slots now and on every
    // announcement, and read the state as well as listening for it to change.
    function promoteNewWorker() {
        skipWaiting(registration.waiting);

        const installing = registration.installing;

        if (!installing || watched.has(installing)) {
            return;
        }

        watched.add(installing);

        const promoteWhenInstalled = () => {
            if (installing.state === 'installed') {
                skipWaiting(installing);
            }
        };

        installing.addEventListener('statechange', promoteWhenInstalled);
        promoteWhenInstalled();
    }

    promoteNewWorker();
    registration.addEventListener('updatefound', promoteNewWorker);
}

function skipWaiting(worker) {
    worker?.postMessage({ type: 'SKIP_WAITING' });
}
